var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 31,
    viewBox: "0 0 18 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36353 2V29",
    stroke: "#4676FA",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.91016H6.29545C5.15623 6.91016 4.06366 7.36271 3.25811 8.16827C2.45256 8.97382 2 10.0664 2 11.2056C2 12.3448 2.45256 13.4374 3.25811 14.243C4.06366 15.0485 5.15623 15.5011 6.29545 15.5011H12.4318C13.571 15.5011 14.6636 15.9536 15.4692 16.7592C16.2747 17.5647 16.7273 18.6573 16.7273 19.7965C16.7273 20.9357 16.2747 22.0283 15.4692 22.8339C14.6636 23.6394 13.571 24.092 12.4318 24.092H2",
    stroke: "#4676FA",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.641e819c124d76fd696d544b6cd97908.svg";
export { ForwardRef as ReactComponent };